import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { translations } from '../translations/zh';

const Navbar = () => {
  const location = useLocation();
  const navItems = [
    { key: "home", label: translations.nav.home, path: "/" },
    { key: "about", label: translations.nav.about, path: "/about" },
    { key: "services", label: translations.nav.services, path: "/services" },
    { key: "contact", label: translations.nav.contact, path: "/contact" }
  ];
  
  const staggerNavItems = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const navItemVariant = {
    hidden: { opacity: 0, y: -20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <motion.nav
      className="flex justify-between items-center px-8 py-4 backdrop-blur-sm bg-white/30"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.65, 0, 0.35, 1] }}
    >
      <Link to="/">
        <motion.div 
          className="text-[#3D587D] font-bold text-2xl flex items-center"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <img src="/logo_transparent.png" alt="ctrlcv logo" className="h-10 w-auto" />
        </motion.div>
      </Link>
      <motion.ul 
        className="flex space-x-6"
        variants={staggerNavItems}
        initial="hidden"
        animate="show"
      >
        {navItems.map((item) => (
          <Link key={item.key} to={item.path}>
            <motion.li
              variants={navItemVariant}
              whileHover={{ 
                scale: 1.1,
                color: "#407CBD",
                transition: { type: "spring", stiffness: 400 }
              }}
              className={`cursor-pointer relative group ${
                location.pathname === item.path ? 'text-[#407CBD]' : ''
              }`}
            >
              {item.label}
              <motion.div
                className={`absolute -bottom-1 left-0 h-0.5 bg-[#407CBD] ${
                  location.pathname === item.path ? 'w-full' : 'w-0 group-hover:w-full'
                }`}
                transition={{ duration: 0.3 }}
              />
            </motion.li>
          </Link>
        ))}
      </motion.ul>
    </motion.nav>
  );
};

export default Navbar; 